import requestAction from '../utils/requestAction'

export const fetchPlatforms = () =>
  requestAction('PLATFORM_LIST')('platforms', 'GET')
